import { useT05LeadForm } from '../hooks/useT05LeadForm';
import { LEAD_USER_MESSAGES } from '../services/leadTypes';
import type { T05ProductPageProps } from '../components/products/t05/routes.fragment';

export interface T05ProductLeadConfig {
  interest: string;
  quelle: string;
}

/** Gemeinsamer Lead-Hook für T05-Produktseiten (Hero + Demo-Modal). */
export function useT05ProductLead(
  { onLeadSubmit }: Pick<T05ProductPageProps, 'onLeadSubmit'>,
  { interest, quelle }: T05ProductLeadConfig,
) {
  return useT05LeadForm({
    onLeadSubmit:
      onLeadSubmit ??
      (async () => ({
        ok: false,
        status: 'error' as const,
        message: LEAD_USER_MESSAGES.networkError,
      })),
    defaultInterest: interest,
    quelleHero: quelle,
    quelleModal: quelle,
    watchOpenLeadParam: true,
  });
}
